import { UserQuestionRequest, UserQuestionResponse } from '../../../types/user'
import { useApiPostQuery } from '../useApi'

export const useUserQuestion = (requestData: UserQuestionRequest) => {
  return useApiPostQuery<UserQuestionResponse>(
    '/user/question',
    ['userQuestion', requestData],
    requestData,
    !!requestData.LEVEL_ID
  )
}
